var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacilityColorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49019 2.25H3.8177C2.3252 2.25 1.5752 3.0075 1.5752 4.515V16.5H5.6252V13.6875C5.6252 13.38 5.8802 13.125 6.1877 13.125C6.4952 13.125 6.7502 13.3725 6.7502 13.6875V16.5H10.7252V4.515C10.7252 3.0075 9.98269 2.25 8.49019 2.25ZM8.0627 9.5625H4.3502C4.0427 9.5625 3.7877 9.3075 3.7877 9C3.7877 8.6925 4.0427 8.4375 4.3502 8.4375H8.0627C8.37019 8.4375 8.6252 8.6925 8.6252 9C8.6252 9.3075 8.37019 9.5625 8.0627 9.5625ZM8.0627 6.75H4.3502C4.0427 6.75 3.7877 6.495 3.7877 6.1875C3.7877 5.88 4.0427 5.625 4.3502 5.625H8.0627C8.37019 5.625 8.6252 5.88 8.6252 6.1875C8.6252 6.495 8.37019 6.75 8.0627 6.75Z",
    fill: "url(#paint0_linear_6366_73189)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 15.9373H15.5475V13.6873C16.26 13.4548 16.7775 12.7873 16.7775 11.9998V10.4998C16.7775 9.51734 15.975 8.71484 14.9925 8.71484C14.01 8.71484 13.2075 9.51734 13.2075 10.4998V11.9998C13.2075 12.7798 13.7175 13.4398 14.415 13.6798V15.9373H0.75C0.4425 15.9373 0.1875 16.1923 0.1875 16.4998C0.1875 16.8073 0.4425 17.0623 0.75 17.0623H14.9475C14.9625 17.0623 14.97 17.0698 14.985 17.0698C15 17.0698 15.0075 17.0623 15.0225 17.0623H17.25C17.5575 17.0623 17.8125 16.8073 17.8125 16.4998C17.8125 16.1923 17.5575 15.9373 17.25 15.9373Z",
    fill: "url(#paint1_linear_6366_73189)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6366_73189",
    x1: 6.1502,
    y1: 2.25,
    x2: 6.1502,
    y2: 16.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39B6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D88D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6366_73189",
    x1: 9,
    y1: 8.71484,
    x2: 9,
    y2: 17.0698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39B6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D88D0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilityColorIcon);
export default __webpack_public_path__ + "static/media/facility-color-icon.b38b035ca7bdc17888bec3d49d86aceb.svg";
export { ForwardRef as ReactComponent };